/*
 * Created by Vladimir Shishlyannikov on 01/03/2023.
 *
 * Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 */

import moment from "moment-timezone";

export const defaultDateFormat = "MM/DD/YYYY HH:mm:ss";

export const getMoment = (value, format, culture) => {
  return culture
    ? moment(value, format, true).locale(culture)
    : moment(value, format, true);
};

export const convertDateToLATimeZone = (value, culture) => {
  var dateFormatted = getMoment(value).format(defaultDateFormat);

  return culture
    ? moment
        .tz(dateFormatted, defaultDateFormat, "America/Los_Angeles")
        .locale(culture)
    : moment.tz(dateFormatted, defaultDateFormat, "America/Los_Angeles");
};

export const getTz = (region = "GB") =>
  region === "GB" ? "Europe/London" : "America/Los_Angeles";

export const getMomentWithTz = (value, region, culture) => {
  // TODO make format as an optional argument
  return culture
    ? moment.tz(value, getTz(region)) //.locale(culture)
    : moment.tz(value, getTz(region));
};

/**
 * Checks if date is in 5:30 to 23:30 day range
 * @param date - Date in native format
 */
export const isDateInDayRange = (date, region) => {
  const momentDate = getMomentWithTz(date, region);
  const startDate = momentDate.clone().startOf("day").add(330, "minutes"); // 05:30
  const endDate = momentDate.clone().startOf("day").add(1410, "minutes"); // 23:30

  return (
    momentDate.isSameOrAfter(startDate) && momentDate.isSameOrBefore(endDate)
  );
};

export const isDateAvailable = (date, days = []) => {
  if (!date) {
    return date;
  }

  if (!(date instanceof Date)) {
    throw new TypeError("'date' has wrong type.");
  }

  // var momentDate = ;
  var day = getMomentWithTz(date).format("YYYY-MM-DD");

  return days.some((d) => d === day);
};

/**
 * @param {object} value Date object
 * @param {Date} min
 * @param {Date} min
 * @param {Array} timSlots
 * @returns {Boolean}
 */

export const inRangeTime = (value, min, max, timeSlots) => {
  if (value === undefined || value == null) {
    console.warn("Time is undefined or null");

    return value;
  }

  if (!(value instanceof Date)) {
    throw new TypeError("Value of argument 'value' violates contract.");
  }

  var date = getMoment(value);

  if (!(date.isSameOrAfter(min) && date.isSameOrBefore(max))) {
    return false;
  }

  if (timeSlots && timeSlots.length) {
    return timeSlots.some(
      (slot) =>
        // There might be some bugs as previously we compare only hours
        date.hours() === slot.start.getHours() &&
        date.minutes() === slot.start.getMinutes()
    );
  }

  return true;
};

/**
 * Merges date (date part) with time (time part)
 * @param date
 * @param time
 * @param defaultDate
 * @returns {Date}
 */
export const merge = (date, time, defaultDate, region) => {
  var dateCloned = getMomentWithTz(date, region);
  var timeCloned = getMomentWithTz(time, region);

  dateCloned = dateCloned.startOf("day");
  dateCloned.hours(timeCloned.hours());
  dateCloned.minutes(timeCloned.minutes());
  dateCloned.seconds(timeCloned.seconds());

  return dateCloned.toDate();
};

// Converts timezone offset in minutes (that should be added to the local time to get GMT/UTC)
// to hours in the following format "UTC+/-XX"
export const UTCOffsetFromMinutes = (offset) => {
  var sign = offset <= 0 ? "+" : "-";
  var minutes = Math.abs(offset);
  var hours = Math.floor(minutes / 60);

  return `${sign}${hours}`;
};
